import { HTML_LINK_TARGET } from '../../../constants/html'
import { PROFILE_ROUTE_NAMES } from '../../../constants/route'
import { isApiNotFoundStatus } from '../../../utils/api'
import { getRentalPortalApplicantIdentityLabel } from '../../RentalPortalApplicant'

import { QA_NAME_APPLICANT_PROFILE_PREVIEW_OPEN_FULL_PAGE } from './RentalPortalApplicantProfile.constants'

export function getApplicantProfileTitle({ applicantData, t }) {
  return applicantData
    ? getRentalPortalApplicantIdentityLabel({ applicant: applicantData, t })
    : null
}

export function getIsApplicantProfileNotFound(serverError) {
  return isApiNotFoundStatus(serverError?.status)
}

export function getIsApplicantClosed(applicantData) {
  return Boolean(
    applicantData?.archived ||
    applicantData?.phase?.is_terminal ||
    applicantData?.terminal_at
  )
}

export function getApplicantProfilePreviewOpenFullPageProps({
  Actions,
  applicantId,
  t,
  onClosePreview,
}) {
  function getProfileLink({ id }) {
    return PROFILE_ROUTE_NAMES.rentalPortalApplicantProfile({ id })
  }

  return {
    Actions,
    getProfileLink,
    id: applicantId,
    openInNewTabButtonProps: {
      qaName: QA_NAME_APPLICANT_PROFILE_PREVIEW_OPEN_FULL_PAGE,
      tooltip: t('RentalPortal.ListingProfilePreviewOpenFullPageBtnKey'),
    },
    openLinkTarget: HTML_LINK_TARGET.self,
    onClosePreview,
  }
}
